class TrendingSlideIn extends HTMLElement {
  constructor() {
    super();
    this.timeout = null;
  }

  connectedCallback() {
    this.timeout = setTimeout(() => {
      this.classList.add('active');
    }, 2000);

    this.querySelector('.trending_slide-in--close').addEventListener('click', () => {
      this.classList.remove('active');
    });
  }

  disconnectedCallback() {
    clearTimeout(this.timeout);
  }
}

customElements.define('trending-slide-in', TrendingSlideIn);